module.exports = __webpack_public_path__ + "static/media/right.6b47867e.svg";